import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import ReactGA from 'react-ga';
import { analyticsKey } from '../../../config';
import PhoneIcon from '../../icons/phone.svg';
import { formatPhone } from '../../utils/phoneFormatter';
import Button from '../Button/Button';
import Form from '../FormSteps';
import Hero from '../Hero/Hero';
import Map from '../Map/Map';
import Modal from '../Modal/Modal';
import Reviews from '../Reviews/Reviews';
import Schedule from '../Schedule/Schedule';
import Services from '../Services/Services';
import styles from './index.module.scss';

const pageName = 'microsite';

const Content = ({ data, preview }) => {
  const [showModal, setShowModal] = useState(false);
  const phoneNumber = formatPhone(data.jobox_number, true);

  useEffect(() => {
    if (analyticsKey) {
      ReactGA.pageview(pageName);
    }
  }, []);

  const setupServices = () => {
    if (data.skillset.length === 0) {
      return data.occupation_services;
    }
    const hasAnyServices = data.skillset.find((skill) => !!skill.job_service_id);

    if (hasAnyServices) {
      return data.skillset;
    }
    return data.occupation_services;
  };

  const services = setupServices() || [];
  const { schedule } = data;

  return (
    <>
      <Hero data={data} />
      <div className={styles.content}>
        <div className={`${styles.servicesContainer} ${services.length > 0 ? styles.hasServices : ''}`}>
          {services.length > 0 && (
            <>
              <h4>Services provided</h4>
              <Services services={services} occupationId={data.occupation_id} />
            </>
          )}
          <div className={styles.mobile}>
            {schedule.length > 0 && (
              <>
                <h4>Working hours</h4>
                <Schedule schedule={schedule} />
              </>
            )}
            <h4>Location</h4>
            <Map baseZip={data.base_zip} radius={data.work_radius} />
            {(data.reviewsData || data.ratings) && <Reviews yelpReviews={data.reviewsData?.reviews} jbReviews={data.ratings} />}
          </div>
        </div>
        <div className={styles.mapContainer}>
          <h4 className={styles.subTitle}>Request a service now</h4>
          <p className={styles.description}>Fill out a short order form or call directly</p>
          <div className={styles.buttons}>
            <Button variant={'dark'} onClick={() => setShowModal(true)} disabled={preview}>
              Book a service
            </Button>
            <a className={styles.callButton} href={`tel:${data.jobox_number}`}>
              <Button onClick={() => {}}>
                <PhoneIcon />
                {`Call ${phoneNumber}`}
              </Button>
            </a>
          </div>
          <div className={styles.desktop}>
            <Map baseZip={data.base_zip} radius={data.work_radius} />
            <div className={styles.hours}>
              {schedule.length > 0 && (
                <>
                  <h4>Working hours</h4>
                  <Schedule schedule={schedule} />
                </>
              )}
            </div>
            {(data.reviewsData || data.ratings) && <Reviews yelpReviews={data.reviewsData && data.reviewsData.reviews} jbReviews={data.ratings} />}
          </div>
        </div>
      </div>
      <Modal onClose={() => setShowModal(false)} show={showModal}>
        <Form
          data={data}
          services={services}
          handleClose={() => {
            document.body.style.position = '';
            setShowModal(false);
          }}
        />
      </Modal>
    </>
  );
};

Content.propTypes = {
  data: PropTypes.shape({
    schedule: PropTypes.array,
    jobox_number: PropTypes.string,
    base_zip: PropTypes.string,
    work_radius: PropTypes.number,
    occupation_id: PropTypes.number,
    skillset: PropTypes.array,
    occupation_services: PropTypes.array,
    reviewsData: PropTypes.shape({
      reviews: PropTypes.array,
    }),
    ratings: PropTypes.array,
  }),
  preview: PropTypes.bool,
};

export default Content;
